// IMPORTS
// Modules
import { useState } from 'react';
// OHS
import { OHSListDataFormatter } from '../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../onehivesystems/js/OHSCRUD';
// Assets
import { userAccountModel, privilegeLevels } from './../_variables';


// COMPONENT
export default function User (props) {
   // States and Variables
   const [changePassword, setChangePassword] = useState(false);
   const [isAdministrator, setIsAdministrator] = useState(props.content.privilege_level.value === "Administrator");

   // Functions
   const updateUserAccount = function () {
      OHSCRUD({
         url: '/v1/useraccounts/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('useraccounts-user'),
         success: function (data) {
            var temp = props.parent.userAccounts;
            temp[props.index] = OHSListDataFormatter(data[0], userAccountModel);
            props.parent.setUserAccounts(temp)
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteUserAccount = function () {
      OHSCRUD({
         url: '/v1/useraccounts/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.userAccounts;
            temp.splice(props.index, 1);
            props.parent.setUserAccounts(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this user account?",
         showSuccessPopup: true
      });
   }
   const toggleChangePassword = function () {
      setChangePassword(!changePassword);
   }
   const toggleIsAdministrator = function (event) {
      if (event.target.value === "Administrator") {
         setIsAdministrator(true);
      } else {
         setIsAdministrator(false);
      }
   }

   // Component
   return (
      <div id='useraccounts-user' className='useraccounts-user' onKeyDown={(e) => {OHSFormSubmitListener(e, updateUserAccount);}}>
         <OHSFormItem onehive={props.onehive} title="Username">
            <input type='text' className='ohsinput' data-ohsformdata='username' min={1} max={256} defaultValue={props.content.username.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Password">
            {changePassword ? 
               <div className='useraccounts-user-changepassword'>
                  <input type='password' className='ohsinput' data-ohsformdata='password' min={1} placeholder='Password' />
                  <input type='password' className='ohsinput' data-ohsformdata='confirm_password' min={1} placeholder='Confirm Password' />
                  <button className='ohsbtn-error' onClick={toggleChangePassword}>Cancel</button>
               </div>
            :
               <button className='ohsbtn' onClick={toggleChangePassword}>Change Password</button>
            }
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="First Name">
            <input type='text' className='ohsinput' data-ohsformdata='first_name' placeholder="(Optional)" min={0} max={256} defaultValue={props.content.first_name.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Last Name">
            <input type='text' className='ohsinput' data-ohsformdata='last_name' placeholder="(Optional)" min={0} max={256} defaultValue={props.content.last_name.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Privilege Level">
            <OHSFormSelectBuilder onehive={props.onehive} content={privilegeLevels} selected={props.content.privilege_level.value} simple={true} blank={false} ohsformdata='privilege_level' onchange={(e) => {toggleIsAdministrator(e);}} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Source">
            <p className='useraccounts-user-source'>{props.content.source.value}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Access: OneACL">
            <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneacl' defaultChecked={props.content.app_oneacl.value} disabled={isAdministrator} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Access: OneChange">
            <input type='checkbox' className='ohsinput' data-ohsformdata='app_onechange' defaultChecked={props.content.app_onechange.value} disabled={isAdministrator} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Access: OneEye">
            <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneeye' defaultChecked={props.content.app_oneeye.value} disabled={isAdministrator} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Access: OneIP">
            <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneip' defaultChecked={props.content.app_oneip.value} disabled={isAdministrator} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Access: OnePort">
            <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneport' defaultChecked={props.content.app_oneport.value} disabled={isAdministrator} />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateUserAccount} clear={() => {OHSFormDataClearer('useraccounts-user');}} delete={deleteUserAccount} keyListener={true} />
      </div>
   );
}